<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('reducer.label')" :columns="6">
        <input v-model="options.stock.reducer" type="number" min="0" class="form-input"/>
      </form-group>
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      options: {
        stock: {
          reducer: 0
        }
      },
      disabled: true,
      source: {}
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      getOptions () {
        return this.options
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .form-checkbox
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// Options.vue?4fece84a